export default __webpack_public_path__ + "static/media/Greenhouse_04.af014270.webp";